import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
// import { Container, Grid } from "@mui/material";
import Register from './pages/register/Register.jsx';
import Home from './pages/home/Home.jsx';
import OpenStore from './pages/openStore/OpenStore.js';
import Login from './pages/login/Login.js';
import ProductDetails from "./pages/product/ProductDetails.js";
import ProductList from "./pages/product/ProductList.js";
import ForgotPassword from './pages/forgotPassword/ForgotPassword.js';
import Card from "./pages/card/Card.js";
import StoreProduct from "./pages/stores/StoreProduct.js";
import User from "./pages/user/User.js";
import CategoriesProduct from "./pages/categories/CategoriesProduct.js";
import Favorite from "./pages/product/Favorite.js";
import SearchBar from "./components/SearchBar.js";
import Layout from "./layout/Layout.js";
import Payment from "./pages/payment/Payment.js";
import SearchResults from "./components/SearchResults.js";
import Institutional from "./pages/agreement/Institutional.js";
import Panel from "./pages/admin/Panel.js";
import Magaza from "./pages/magaza/Magaza.js";
import PaymentResult from "./pages/payment/PaymentResult.js";
import { v4 as uuidv4 } from 'uuid';
import Link from "./context/Link.js";
import Certificate from "./pages/certificate/Certificate.js";
import WhatsAppButton from './components/WhatsAppButton';
// import AIChatbox from './components/AIChatbox';
import TermsOfUse from "./pages/agreement/TermsOfUse.js";
import DistanceSalesAgreement from "./pages/agreement/DistanceSalesAgreement.js";
import ShippingAndReturns from "./pages/agreement/ShippingAndReturns.js";
import NotFound from "./pages/notFound/NotFound.js";
import SharedCart from "./pages/card/SharedCart.js";
import "./assest/Toast.css";
import ScrollToTopButton from "./components/ScrollToTopButton.js";
import PrivateRoute from './components/PrivateRoute';
import CampaignProducts from "./components/campainProduct/CampaignProducts.js";
import OrderDetails from "./components/user/OrderDetails.js";
import { getApiUrl } from "./config.js";
import BlogList from "./pages/blog/BlogList.js";
import BlogDetail from "./pages/blog/BlogDetail.js";
import { initializeSitemap } from './utils/initializeSitemap';
// import SitemapRoute from './components/SitemapRoute';
import CookieSettingsPage from './pages/cookieSettings/CookieSettingsPage.js';
import { CookieProvider } from './context/CookieContext.js';
import CookieBanner from "./components/CookieBanner.js";
import CookieSettings from './components/CookieSettings.js';
import EFT from "./components/user/EFT.js";
const checkAuth = async () => {
  const token = localStorage.getItem("token");
  const tkn = localStorage.getItem("tkn");

  if (!token || !tkn) return;

  try {
    const response = await fetch(`${getApiUrl()}/user`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
        Tkn: `${tkn}`,
      },
    });

    if (response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("tkn");

    }
  } catch (error) {
    console.error("Auth kontrolü başarısız:", error);
  }
};

const createToken = () => {
  const token = `bikuyum-${uuidv4()}`;

  localStorage.setItem('tkn', token);
  return token;
};

const getToken = () => {
  let token = localStorage.getItem('tkn');
  if (!token || token == null || token == "" || token == "null") {
    token = createToken();
  }
  return token;
};

function App() {

  useEffect(() => {
    checkAuth();

    // Sitemap otomatik güncellemeyi başlat
    // initializeSitemap();
  }, []);

  const token = getToken();

  return (
    <CookieProvider>
      <Router>
        <Link />
        <Layout>
          {/* <Container maxWidth="xl" style={{ paddingBottom: '20px' }}> */}
          <Routes>
            <Route path="/" element={<Home />} />

            <Route path="/favorite" element={<Favorite />} />
            <Route path="/productList" element={<ProductList />} />
            <Route path="/kampanyaliurunler" element={<CampaignProducts />} />
            <Route path="/urun/:sef" element={<ProductDetails />} />

            <Route path="/searchBar" element={<SearchBar />} />
            <Route path="/search" element={<SearchResults />} />

            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />

            <Route path="/user" element={<PrivateRoute><User /></PrivateRoute>} />
            <Route path="/orderDetails" element={<PrivateRoute><OrderDetails /></PrivateRoute>} />

            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/openStore" element={<OpenStore />} />
            <Route path="/card" element={<Card />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/payment-result/:status" element={<PaymentResult />} />
            <Route path="/shared-cart/:shareCode" element={<SharedCart />} />

            <Route path="/institutional" element={<Institutional />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/distance-sales-agreement" element={<DistanceSalesAgreement />} />
            <Route path="/shipping-and-returns" element={<ShippingAndReturns />} />

            <Route path="/panel" element={<Panel />} />
            <Route path="/magaza" element={<Magaza />} />
            <Route path="/sertifika/:cardNo" element={<Certificate />} />

            {/* Blog sayfaları */}
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />

            {/* Çerez ayarları sayfası */}
            <Route path="/cerez-ayarlari" element={<CookieSettingsPage />} />

            {/* 404 sayfası için özel rota */}
            <Route path="/404" element={<NotFound />} />

            <Route path="/:kullanici_id/:kategori" element={<StoreProduct />} />

            {/* Sitemap route'u */}
            {/* <Route path="/sitemap.xml" element={<SitemapRoute />} /> */}

            <Route path="/:id" element={<CategoriesProduct />} />

            {/* 404 sayfası için catch-all yönlendirme */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          {/* </Container> */}
          {/* <AIChatbox /> */}
          <WhatsAppButton />
          <ScrollToTopButton />
        </Layout>
        
        {/* Çerez bileşenleri */}
        <CookieBanner />
        <CookieSettings />
      </Router>
    </CookieProvider>
  );
}

export default App;
